/* ImageSelect - image selection and annotation for annotator

Requires imgAreaSelect.js.
http://odyniec.net/projects/imgareaselect/

Specify the image(s) to be selected when including the module, e.g.

    .include(annotatorImageSelect, {
        element: $('.content img'),
    })


*/

function annotatorImageSelect(options) {
  var _t = annotator.util.gettext,
    global = this;  // equivalent to previously used annotator.util.getGlobal()

  options = options || {};

  // Object to hold local state
  var s = {
    interactionPoint: null,
    ias: null
  };

  var anns = {};
  var legantoUtil = getAnnotationLegantoUtil.get();

  function createNewAnnotation(annotation){
    // hide the temporary highlight
    $(".active-img-selection").removeClass('.active-img-selection');
    // show image highlight div for new image annotation
    imgselect_utils.drawImageHighlight(anns['new']);
    legantoUtil.addOffset(annotation);
    return true;
  }

  function convertSelectionToRotationZero(selection, rotation, orgWidth, orgHeight){
    switch(rotation){
      case 90: return {
        x1 : selection.y1,
        y1 : orgHeight - selection.x2,
        x2 : selection.y2,
        y2 : orgHeight - selection.x1,
        height : selection.width,
        width : selection.height
      }
      case 180: return {
        x1 : orgWidth - selection.x2,
        y1 : orgHeight - selection.y2,
        x2 : orgWidth - selection.x1,
        y2 : orgHeight - selection.y1,
        height : selection.height,
        width : selection.width
      }
      case 270: return {
        x1 : orgWidth - selection.y2,
        y1 : selection.x1,
        x2 : orgWidth - selection.y1,
        y2 : selection.x2,
        height : selection.width,
        width : selection.height
      }
    }
  }
  
  // utility methods to support image annotation
  var imgselect_utils = {
    // image area inital setup
    selectionSetup: function() {
      $(document)
        .on('click.imgselection','.imgareaselect-outer', '.annotator-cancel', function(evt) {
          $(".tmp-img-selection").remove();
        });
      // escape key exits editor, so should also clear temporary selection
      $('.annotator-editor textarea').on('keydown', function(e) {
        if (event.which === 27) {  // escape
          $(".tmp-img-selection").remove();
        }
      });
      return true;
    },

    hideAnnotatorEditorAdder: function() {
      // hide annotator editor window, adder button, and deselect text
      // whenever an image selection is drawn or adjusted

      // hide editor if visible
      var $visible_editor = $(".annotator-editor:not(.annotator-hide)");
      if ($visible_editor.length > 0){
        $visible_editor.addClass('annotator-hide');
      }
      // hide the adder whenever a new selection is started
      s.adder.hide();
      // unselect any selected text to avoid confusion
      // between text/image selection & annotation
      global.getSelection().removeAllRanges();
    },

    // image area selection start event
    selectionStart: function(img, selection) {
      imgselect_utils.hideAnnotatorEditorAdder();
    },

    // image area selection change event
    selectionChange: function(img, selection) {
      imgselect_utils.hideAnnotatorEditorAdder();
    },

    // image area selection end event
    selectionEnd: function(img, selection) {
      // only display adder once selection gets above a certain
      // minimum size
      // TODO: make min size configurable (?)
      if (selection.width < 25 || selection.height < 25) {
        return;
      }
      // create a preliminary annotation object.
      // based on makeAnnotation from annotator.ui.main
      var annotation =  {
        quote: '',   // image selection = no text quotation
        // NOTE: normal highlights include xpath dom ranges
        // we don't have anything like that, but annotator
        // seems happy enough with an empty list.
        ranges: [],
        // image selection details
        image_selection : imgselect_utils.imageSelection(img.previousElementSibling, selection)
      };
      anns['new'] = annotation;
      anns['new'].img = img;
      anns['new'].selection = selection;

      if(!options.config.attachComment){
        dispatchNewAnnEvent();
        setTimeout(() => onCreate(anns['new']), 0);
      }else{
        showQuickComment(anns['new']);
      }
    },

    // draw a highlight element for an image annotation
    drawImageHighlight: function(annotation, rotation) {
      // if annotation is not an image selection annotation,
      // or does not provide needed attributes, skip
                      // if (! annotation.image_selection || ! annotation.image_selection.src) {
                      //   return;
                      // }
      if (! annotation.image_selection){
        return;
      }

      var imgselection = annotation.image_selection;
      // var img = $('img[src$="' + imgselection.src + '"]').first();
      // if (img.length === 0) {
      //   // if the highlighted image is not found, skip
      //   return;
      // }
      // create a highlight element
      var hl = $(document.createElement('span'));
      // hl.addClass('annotator-hl');
      hl.addClass(options.config.className); // ##LEGANTO
      // set position, width, height, annotation id
     
      if(rotation == undefined && sessionStorage.getItem("lgnto.fileRotation") && +sessionStorage.getItem("lgnto.fileRotation") > 0){
        rotation = +sessionStorage.getItem("lgnto.fileRotation");
      }

      let css = this.getBordersByRotation(imgselection, rotation);
      css.position = 'absolute';
      css.display = 'block';
      hl.css(css);
      // Add a data attribute for annotation id if the annotation has one
      if (typeof annotation.id !== 'undefined' && annotation.id !== null) {
       hl.attr('data-annotation-id', annotation.id);
     }

     if (annotation.color || (annotation.attributes && annotation.attributes.color)) {
         hl.attr('color', annotation.color || annotation.attributes.color);
     }

     // Save the annotation data on each highlighter element.
     //hl.attr('data-annotation', JSON.stringify(annotation));

     hl.attr('visibility', annotation.visibility);
     // add highlight to img parent element
     // NOTE: this relies on readux style/layout for correct placement
    //$('pdf-viewer .textLayer').eq(annotation.page - 1).append(hl);
    $(options.elements.findPage(annotation.page)).prepend(hl);
     //img.previousElementSibling
     //img.parent().append(hl);

      // return the added highlight element
      annotation.element = hl;
      annotation.type = pluginType;
      legantoUtil.addOffset(annotation);
      return hl;
    },

    // get position from image + selection
    selectionPosition: function(img, selection) {
      // based on annotator.util.mousePosition
      // body offset logic borrowed from annotator.util
      var body = global.document.body;

      var offset = {top: 0, left: 0};
      if ($(body).css('position') !== "static") {
        offset = $(body).offset();
      }
      // get position based on image offset + selection position
      var img_offset = $(img).offset();
      // setting adder to top right corner of selection for now
      return {
        top: img_offset.top + selection.y1 - offset.top,
        left: img_offset.left + selection.x2 - offset.left
      };
    },

    percent: function(val) {
      // convert image position/size number into percentage
      // for storing in the annotation and displaying highlight
      return Number(val*100).toFixed(2) + '%';
    },

    imageSelection: function(img, selection) {
      // image selection information to be
      // stored with the annotation, so that we can load
      // and display highlighted region
      let rotation = sessionStorage.getItem("lgnto.fileRotation") ? +sessionStorage.getItem("lgnto.fileRotation") : 0;
      let orgWidth = rotation % 180 ? $(img).height() : $(img).width();
      let orgHeight = rotation % 180 ? $(img).width() : $(img).height();
      if(rotation){
        selection = convertSelectionToRotationZero(selection, rotation, orgWidth, orgHeight);
      }
      var percent = imgselect_utils.percent;
      // storing all dimensions as percentages so it can
      // be scaled for different sizes if necessary
      // var w = (selection.x2 - selection.x1) / img.width,
      //    h = (selection.y2 - selection.y1) / img.height;
      var w = (selection.x2 - selection.x1) / orgWidth,
          h = (selection.y2 - selection.y1) / orgHeight;
      return {
        // full uri to the image
        uri: img.src,
        // store src as it appears in the document, so we can find it again
        src: $(img).attr('src'),
        x: percent(selection.x1 / orgWidth),// img.width),
        y: percent(selection.y1 / orgHeight),//img.height),
        w: percent(w),
        h: percent(h)
      };
    },

    getBordersByRotation : function(imgselection, rotation = 0){
      switch(rotation){
        case 0 : return {
          width: imgselection.w,
          height: imgselection.h,
          left: imgselection.x,
          top: imgselection.y,
        };
        case 90 : return {
          width: imgselection.h,
          height: imgselection.w,
          right: imgselection.y,
          top: imgselection.x,
        };
        case 180 : return {
          width: imgselection.w,
          height: imgselection.h,
          right: imgselection.x,
          bottom: imgselection.y
        };
        case 270 :  return {
          width: imgselection.h,
          height: imgselection.w,
          left: imgselection.y,
          bottom: imgselection.x,
        };
      }
      

     }
  };
  var ias_opts = {
    instance: true,  // return an instance for later interaction
    handles: true,
    onInit: imgselect_utils.selectionSetup,
    onSelectStart: imgselect_utils.selectionStart,
    onSelectChange: imgselect_utils.selectionChange,
    onSelectEnd: imgselect_utils.selectionEnd,
    keys: false  // disable keyboard shortcuts because they conflict with annotator keys
 }
 
  function dispatchNewAnnEvent(){
    options.elements.container.dispatchEvent(new CustomEvent('lgntoann.annotation.create', {detail: { tool : options.config.code , ann : anns['new']}}));
  }

  function dispatchImgEvent(){
    options.elements.container.dispatchEvent(new CustomEvent('lgntoann.annotation.addComment', {detail: { tool : options.config.code , ann : anns[lastIdAdded]}}));
  }
  function getAnnForPlugin(ann){
    return Object.assign({}, legantoUtil.getAnnForPlugin(ann));
  }
  
pagesWithPlugin = {};
function shapeOn(page){
  // enable image selection on configured annotatable image 
  let e = options.elements.findAll('img');
  if(page){
    if(pagesWithPlugin[page - 1]) {
      shapeOff();
      s.ias = [];
    }
    s.ias.push($(options.elements.findPage(page)).imgAreaSelect(ias_opts));
    pagesWithPlugin[page - 1] = true;
  }else{
    s.ias = $(e).toArray().map(function(el, i) {
        pagesWithPlugin[i] = true;
        return $(el).imgAreaSelect(ias_opts);
    });
  }

  $(e).css({cursor : 'crosshair'});
  pluginOn = true;
}
function shapeOff(){
  pluginOn = false;
  let e = options.elements.findAll('img');
  s.ias = $(e).toArray().map(function(el) {
      return $(el).imgAreaSelect({remove : true});
  });

  $(e).css({cursor : 'auto'});
  pagesWithPlugin = {};
}

function deleteDraftShape(){
  // hide the image selection tool
  s.adder.hide();
  // cancel image selection box if there is one
  // (mirrors annotator logic for unselecting text)
  if (s.ias !== null) {
    $.each(s.ias, function(idx, ias){if(ias && ias.cancelSelection) ias.cancelSelection();});
  }
}

function addAttr(ann, attr, val){
  if(ann.element) $(ann.element).attr(attr, val ? val : '');
}

function removeAttr(ann, attr){
  if(ann.element) $(ann.element).removeAttr(attr);  
}

function showQuickComment(annotation){
  $(".annotator-adder+div").addClass('active-img-selection');
      // calculate "interaction point" - using top right of selection box
      s.interactionPoint = imgselect_utils.selectionPosition(annotation.img, annotation.selection);
      // show the annotation adder button
      s.adder.load(annotation, s.interactionPoint);

      // set editor window is not positioned relative to the adder element
      var offset = $(s.adder.element[0]).offset();
      if (offset){
        $(".annotator-editor").css({
          top: offset.top + 50,
          left: offset.left - (annotation.selection.width/2)
        });
      }
}

var ias_opts, pluginOn, pluginType, onCreate, lastIdAdded;
// export annotator module hooks
  return {
      destroy :function(){
        document.getElementById('ann-rect').removeEventListener('click', rect);
    },
    config: function(elementsConfig){
      options.elements = elementsConfig;
    },
    // when annotator starts, load & configure image selection
      start: function (app) {
          if (!jQuery.imgAreaSelect || typeof jQuery.imgAreaSelect !== 'function') {
              console.warn(_t("To use the ImageSelect annotator module, you must " +
                  "include imgAreaSelect in the page."));
              return;
          }
          // NOTE: might be possible to set fallback logic to identify
          // annotable image content, but this is probably good enough for now.

          ias_opts = {
            instance: true,  // return an instance for later interaction
            handles: true,
            onInit: imgselect_utils.selectionSetup,
            onSelectStart: imgselect_utils.selectionStart,
            onSelectChange: imgselect_utils.selectionChange,
            onSelectEnd: imgselect_utils.selectionEnd,
            keys: false  // disable keyboard shortcuts because they conflict with annotator keys
         }

          pluginType = options.config.code;
          // s.adder = new annotator.ui.adder.Adder({
          //   onCreate: function (ann) {
          //       app.annotations.create(ann);
          //   }
          // });

          onCreate = function(ann){
            app.annotations.create(ann);
          };
          
          legantoUtil.initQuickAction(options.htmlTemplate, {"tool" : options}, s, (options.config.attachComment ? dispatchNewAnnEvent : dispatchImgEvent));
          //window['annotator'].ui.adder.Adder.template = options.htmlTemplate; //options.htmlTemplate.replace('#QUICK_ACTION_MENU#', options.rect.quickAction.html);
          // create annotation adder
          // borrowed from annotator.ui.main
          
          return true;
      },
      beforeAnnotationCreated: function(annotation) {
        deleteDraftShape();

        // if this is an image annotation,
        // create a temporary highlight to show what is being annotated
        if (annotation.image_selection && annotation.image_selection.src) {
          var tmp_hl = imgselect_utils.drawImageHighlight(annotation);
          if (tmp_hl) {
            tmp_hl.addClass('tmp-img-selection').removeClass('annotator-hl');
          }
        }
        return true;
      },

      annotationCreated: function(annotation) {
        createNewAnnotation(annotation);
        showQuickComment(annotation);
      },

      // nothing to do for annotationUpdated
      // (image selection not currently editable)

      delete: function(annId) {
        let ann = anns[annId] || anns['new'];
        if (ann && ann.image_selection) {
            $('.' + options.config.className + '[data-annotation-id="' + ann.id + '"]').remove();
            annId ? delete anns[annId] : delete anns['new'];
        }
        return true;
      },
      edit: function(annId, cb) {
        let ann = anns[annId] || anns['new'];
        if(!ann) return;
        addAttr(ann, 'edit');
        if(cb) cb();
        return true;
      },
      save: function(annId, cb) {
        let ann = anns[annId] || anns['new'];
        if(!ann) return;
        
        if(options.config.attachComment){
          this.beforeAnnotationCreated(anns['new']);
          createNewAnnotation(anns['new']);
          if(cb) cb();
        }

        if(anns[annId]) {
          ann.commentAttached = true;
          legantoUtil.attachHoverEvent(ann.element, annId, options.elements);
        }
        if(annId && anns['new']){
          anns[annId] = anns['new'];
          anns[annId].id = annId;
          delete anns['new'];
          addAttr(ann, 'data-annotation-id', annId);
          legantoUtil.handleNewAnn(ann, options.config, options.elements);
          lastIdAdded = annId;
        }
        removeAttr(ann, 'edit');
        return true;
      },
      select: function(annId) {
        let ann = anns[annId] || anns['new'];
        if(!ann) return;
        addAttr(ann, 'selected', '');
        options.elements.scrollToAnnotation(ann.element, ann);
        return true;
      },
      scroll: function(annId) {
        let ann = anns[annId] || anns['new'];
        if(!ann) return;
        options.elements.scrollToAnnotation(ann.element, ann);
        
        return true;
      },
      hover: function(annId) {
        let ann = anns[annId] || anns['new'];
        if(!ann) return;
        addAttr(ann, 'hover', '');
        return true;
      },
      unselect: function(annId) {
        let ann = anns[annId] || anns['new'];
        if(!ann) return;
        removeAttr(ann, 'selected', '');
        return true;
      },
      unhover: function(annId) {
        let ann = anns[annId] || anns['new'];
        if(!ann) return;
        removeAttr(ann, 'hover');
        return true;
      },
      deleteAllComments : function(){
          this.deleteAll();
      },
      deleteAll : function(){
        if(!anns) return;
        for(var a in anns){
          this.delete(a);
        }
      },
      load: function(annotations, rotation) {
        // look for any annotations with an image-selection
        // and create positioned div based on the selection coordinates
        // using the same styles as text annotations.
        $.each(annotations, (i) => {
          if(annotations[i].type == pluginType) {
            let a = annotations[i];
            anns[a.id] = getAnnForPlugin(a);
            imgselect_utils.drawImageHighlight(anns[a.id], rotation);
            if(a.id !== 'new') {
              legantoUtil.handleLoadedAnn(anns[a.id], options.config, options.elements);
            }else{
              this.edit();
            }
          }
        });
        // return true so annotator will draw text highlights normally
        return true;
      },
      selectTool : function(newTool, attributes){
        if(newTool != pluginType && pluginOn) shapeOff();
        if(newTool == pluginType && !pluginOn) shapeOn();
        if(!attributes || !attributes.color){
          $('.imgareaselect-selection').attr('color', '');
        }else if(attributes && attributes.color){
          $('.imgareaselect-selection').attr('color', attributes.color);
        }
        delete anns['new'];
        lastIdAdded = '';
        deleteDraftShape();
      },
      newPage : function(pageNum){
        if(pluginOn) shapeOn(pageNum);
      },
      removeAllByConfig : function(annsConfig){
        legantoUtil.runForAllByConfig(annsConfig, annId => {
          if(anns[annId]){
            $('.' + options.config.className + '[data-annotation-id="' + annId + '"]').remove();
            delete anns[annId];
          }
        });
        return true;
      },
      disable : function(toolsCode){
        legantoUtil.disableTools(toolsCode, toolsConfig);        
      },
      reset : function(cb){
          if(!anns) return;
          for(var aId in anns){
              this.delete(aId);
          };
      }
  };
}
